"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationServiceImpl = void 0;
const observable_1 = require("../lib/observable/observable");
const translations = __importStar(require("../translations/index"));
const localstorage_store_1 = require("../lib/store/localstorage-store");
class TranslationServiceImpl {
  constructor(config) {
    var _a, _b;
    this.activeLanguageSubject = new observable_1.Subject("en");
    this.config = config;
    this.store = new localstorage_store_1.LocalStorageStore((_a = config === null || config === void 0 ? void 0 : config.languageStorageName) !== null && _a !== void 0 ? _a : "brynConsentLanguage");
    const languageFromStore = this.store.get();
    for (const language of [languageFromStore, config === null || config === void 0 ? void 0 : config.language, navigator.language.slice(0, 2), document.documentElement.lang.slice(0, 2), (config.availableLanguages || [])[0]]) {
      if (language && ((_b = config.availableLanguages) === null || _b === void 0 ? void 0 : _b.includes(language))) {
        this.setLanguage(language);
        break;
      }
    }
    this.additionalTranslations = config.translations;
  }
  getAllLanguageKeys() {
    return [...new Set(this.config.availableLanguages)];
  }
  getNativeLanguageName(languageKey) {
    return this.translate(["languageName"], languageKey, false) || languageKey;
  }
  observeTranslateFunction() {
    return (0, observable_1.mapObservable)(this.activeLanguageSubject, activeLanguage => {
      return translationKey => this.translate(translationKey, activeLanguage);
    });
  }
  observeLanguage() {
    return this.activeLanguageSubject;
  }
  setLanguage(languageKey) {
    this.activeLanguageSubject.next(languageKey);
    this.store.set(languageKey);
  }
  getObjectValue(key, object) {
    let value = object;
    for (let i = 0; i < key.length; i++) {
      if (!value) {
        continue;
      }
      value = value[key[i]];
    }
    return value;
  }
  getTranslatedString(translationKey, languageKey) {
    return this.getObjectValue(translationKey, this.additionalTranslations[languageKey]) || this.getObjectValue(translationKey, translations[languageKey]);
  }
  translate(translationKey, languageKey) {
    let useFallbackLanguages = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    let string;
    string = this.getTranslatedString(translationKey, languageKey);
    let languagesSeenBefore = [];
    const recursiveGetTranslationString = (startingLanguage, fallbackLanguage) => {
      const currentLanguage = fallbackLanguage[startingLanguage];
      if (languagesSeenBefore.includes(currentLanguage)) {
        return undefined;
      }
      const translatedString = this.getTranslatedString(translationKey, currentLanguage);
      if (translatedString) {
        return translatedString;
      }
      languagesSeenBefore.push(currentLanguage);
      return recursiveGetTranslationString(currentLanguage, fallbackLanguage);
    };
    if (!string && useFallbackLanguages) {
      if (Array.isArray(this.config.fallbackLanguage)) {
        this.config.fallbackLanguage.map(lang => {
          string = string !== null && string !== void 0 ? string : this.getTranslatedString(translationKey, lang);
        });
      } else if (typeof this.config.fallbackLanguage === "object") {
        string = string !== null && string !== void 0 ? string : recursiveGetTranslationString(languageKey, this.config.fallbackLanguage);
      } else {
        string = string !== null && string !== void 0 ? string : this.getTranslatedString(translationKey, this.config.fallbackLanguage || "en");
      }
    }
    return string !== null && string !== void 0 ? string : "";
  }
}
exports.TranslationServiceImpl = TranslationServiceImpl;